import { listEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { publisherBan } from 'root/src/shared/descriptions/endpoints/recordTypes';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { PublisherBanListType } from 'root/src/shared/@types/publisherBanList';
import { publisherListsEndpointIds } from 'root/src/shared/publisherLists/publisherLists.constants';
export const getPublisherBannedCreatorsEndpoint = {
    [publisherListsEndpointIds.GET_PUBLISHER_BANNED_CREATORS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.brand,
        endpointType: listEndpointType,
        recordType: publisherBan,
        payloadSchema: {
            type: 'object',
            properties: {
                dropEventId: {
                    type: 'string',
                },
                banListType: {
                    type: 'string',
                    enum: Object.values(PublisherBanListType),
                },
            },
        },
    },
};
